import React from 'react';
import PropTypes from 'prop-types';

import Button from '@Components/Button';

export default function ResultEditButtons (props) {
  const { id, openAlertDeleteConfirmationDialog, openEditAlert } = props;

  return (
    <section className='result-edit-buttons els-btn-group'>
      <Button
        onClick={() => {
          openEditAlert(id);
        }}
        buttonConfig={{
          className: 'alerts--second-line results-from--edit-button',
          size: 'sm',
          type: 'link',
          label: 'Edit',
          e2eName: `${id}-edit`,
        }}
        iconConfig={{
          name: 'pencil',
        }}
      />
      <Button
        onClick={() => {
          openAlertDeleteConfirmationDialog(id);
        }}
        buttonConfig={{
          className: 'alerts--second-line',
          size: 'sm',
          type: 'link',
          label: 'Delete',
          e2eName: `${id}-delete`,
        }}
        iconConfig={{
          name: 'trash',
        }}
      />
    </section>
  );
}

ResultEditButtons.propTypes = {
  id: PropTypes.string.isRequired,
  openAlertDeleteConfirmationDialog: PropTypes.func.isRequired,
  openEditAlert: PropTypes.func.isRequired,
};
